import {
  Dispatch,
  PropsWithChildren,
  RefObject,
  SetStateAction,
  createContext,
  useRef,
  useState,
  ReactNode,
} from 'react'
import { CAI_CHAT_FLOWS } from 'src/constants/cai-chat.constant'

type Type = {
  show: boolean
  flow: string
  tourAudio: HTMLAudioElement | null
  librarianMsg: ReactNode
  setLibrarianMsg: Dispatch<SetStateAction<ReactNode>>
  chatId: string
  setChatId: Dispatch<SetStateAction<string>>
  didUpdateLanguage: boolean
  setDidUpdateLanguage: Dispatch<SetStateAction<boolean>>
  setShow: Dispatch<SetStateAction<boolean>>
  setFlow: Dispatch<SetStateAction<string>>
  setTourAudio: Dispatch<SetStateAction<HTMLAudioElement | null>>

  notificationRef: RefObject<HTMLDivElement> | null
  sizeBtnRef: RefObject<HTMLDivElement> | null
  draggingBtnRef: RefObject<HTMLDivElement> | null
  librarianRef: RefObject<HTMLButtonElement> | null
  feedFwdRef: RefObject<HTMLButtonElement> | null
  goalRef: RefObject<HTMLButtonElement> | null
  agentChatRef: RefObject<HTMLDivElement> | null
  newChatRef: RefObject<HTMLButtonElement> | null
  languageSelectionRef: RefObject<HTMLDivElement> | null
  profileSelectionRef: RefObject<HTMLDivElement> | null
  aiChatIconRef: RefObject<HTMLButtonElement> | null
  hubMenuItem: RefObject<HTMLDivElement> | null
  goalMenuItem?: RefObject<HTMLDivElement> | null
  goalBtnRef: RefObject<HTMLButtonElement> | null
  tourOpen: boolean
  setTourOpen: Dispatch<SetStateAction<boolean>>
  audio: HTMLAudioElement | null
  setAudio: Dispatch<SetStateAction<HTMLAudioElement | null>>
}

export const CaiPopupContext = createContext<Type>({
  show: false,
  flow: CAI_CHAT_FLOWS.DEFAULT,
  tourAudio: null,
  tourOpen: false,
  librarianMsg: null,
  setTourOpen: () => {},
  setShow: () => {},
  setFlow: () => {},
  setTourAudio: () => {},
  setLibrarianMsg: () => {},
  notificationRef: null,
  sizeBtnRef: null,
  draggingBtnRef: null,
  librarianRef: null,
  feedFwdRef: null,
  goalMenuItem: null,
  goalBtnRef: null,
  goalRef: null,
  agentChatRef: null,
  newChatRef: null,
  languageSelectionRef: null,
  profileSelectionRef: null,
  aiChatIconRef: null,
  hubMenuItem: null,
  chatId: '',
  setChatId: () => {},
  didUpdateLanguage: false,
  setDidUpdateLanguage: () => {},
  audio: null,
  setAudio: () => {},
})

export default function CaiPopupProvider({ children }: PropsWithChildren) {
  const [show, setShow] = useState(false)
  const [flow, setFlow] = useState(CAI_CHAT_FLOWS.DEFAULT)
  const [chatId, setChatId] = useState('')
  const [didUpdateLanguage, setDidUpdateLanguage] = useState(false)
  const [tourAudio, setTourAudio] = useState<HTMLAudioElement | null>(null)
  const [tourOpen, setTourOpen] = useState(false)
  const [librarianMsg, setLibrarianMsg] = useState<ReactNode | null>(null)
  const [audio, setAudio] = useState<HTMLAudioElement | null>(null);

  const notificationRef = useRef<HTMLDivElement | null>(null)
  const librarianRef = useRef<HTMLButtonElement | null>(null)
  const feedFwdRef = useRef<HTMLButtonElement | null>(null)
  const goalRef = useRef<HTMLButtonElement | null>(null)
  const agentChatRef = useRef<HTMLDivElement | null>(null)
  const sizeBtnRef = useRef<HTMLDivElement | null>(null)
  const draggingBtnRef = useRef<HTMLDivElement | null>(null)
  const newChatRef = useRef<HTMLButtonElement | null>(null)
  const languageSelectionRef = useRef<HTMLDivElement | null>(null)
  const profileSelectionRef = useRef<HTMLDivElement | null>(null)
  const aiChatIconRef = useRef<HTMLButtonElement | null>(null)
  const hubMenuItem = useRef<HTMLDivElement | null>(null)
  const goalMenuItem = useRef<HTMLDivElement | null>(null)
  const goalBtnRef = useRef<HTMLButtonElement | null>(null)

  return (
    <CaiPopupContext.Provider
      value={{
        show,
        setShow,
        tourOpen,
        setTourOpen,
        flow,
        setFlow,
        chatId,
        setChatId,
        tourAudio,
        setTourAudio,
        librarianMsg,
        setLibrarianMsg,
        sizeBtnRef,
        draggingBtnRef,
        librarianRef,
        feedFwdRef,
        goalRef,
        notificationRef,
        agentChatRef,
        newChatRef,
        languageSelectionRef,
        profileSelectionRef,
        aiChatIconRef,
        hubMenuItem,
        goalMenuItem,
        goalBtnRef,
        didUpdateLanguage,
        setDidUpdateLanguage,
        audio,
        setAudio,
      }}
    >
      {children}
    </CaiPopupContext.Provider>
  )
}
